import { useEffect, useState } from 'react';

import axiosPixLink from 'config/axiosPixLink';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import ConsultantHistoricalBacklinkingsTableControl from 'components/Netlinking/Table/Consultant/ConsultantHistoricalBacklinkingsTableControl';
import ConsultantSearchSpotTableControl from 'components/Netlinking/Table/Consultant/ConsultantSearchSpotTableControl';
import ConsultantSelectedSpotTableControl from 'components/Netlinking/Table/Consultant/ConsultantSelectedSpotTableControl';
import { MyCustomHighchartsSmall } from 'components/shared/Charts/MyCustomHighChartsSmall';
import { MyCustomHighcharts } from 'components/shared/Charts/MyCustomHighcharts';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import ExcelUploaderSelection from 'components/shared/UploadExcel/UploadExcelSelection';
import UploadSpotModal from 'components/shared/modal/UploadSpotModal';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
  COLOR_JAUGE,
  PIXLINK_CAMPAIGN_STATUS,
  PIXLINK_STATUS,
} from 'utils/Constants';
import { useHistoryState } from 'utils/hooks/useHistoryState';
import {
  calculateClientMinimumLinks,
  calculateMinimumLinks,
} from 'utils/netlinking/linksNumber';
import './order.css';

import {
  calculateConsultantRefusedPixalione,
  calculateConsultantRefusedClient,
  calculateConsultantToBeCommanded,
  calculateConsultantToBeFilteredConsultant,
  calculateConsultantValidateClient,
  calculateConsultantValidateSuperAdmin,
  calculateConsultantValidateSuperConsultant,
} from 'utils/Jauge/CalculateConsultant';
import { MyCustomReverseHighChats } from 'components/shared/Charts/MyCustomReverseHighChats';
const API = {
  getAvailableThematics: '/netlinking/all-thematics',
  getAvailableLanguages: '/language/all',
  getExistingAccounts: 'website/account/all',
  getAllWriters: '/user/all',
  getAllWebsiteOfAccount: '/website',
  getAllDevisOfAccount: '/user/getDevise',
  updateCampaign: '/campaign/update',
  createSmartOrder: '/commands/addSmartCommand',
  getAllConsultants: '/user/consultants',
  getAllSuperConsultants: 'user/superconsultants',
  getCampaignDetail: '/campaign/campaignDetail/',
};

export default function ConsultantCampaignSourcing({
  campaignType,
  campaignStatus,
  setCampaignStatus,
  handleNetlinkingData,
  handleTmpNetlinkingData, sendNewCampaignTarif
}) {
  const dispatch = useDispatch();
  const [urlSearch, setUrlSearch] = useHistoryState('urlSearch', '');
  const { id } = useParams();
  const history = useHistory();
  const { t } = useTranslation();
  const [wantedNetlinkings, setWantedNetlinkings] = useState([]);
  const [historicBackLinkings, setHistoricBackLinkings] = useState([]);
  const [netlinkings, setNetlinkings] = useState([]);
  const [netlinkingsTmp, setNetlinkingsTmp] = useState([]);
  const [nbrOfLinksDemanded, setNbrOfLinksDemanded] = useState(0);
  const [nameSearch, setNameSearch] = useState('');
  const [netlinkingContactFilter, setNetlinkingContactFilter] = useState('');
  const [ordersPerPage, setOrdersPerPage] = useState(10);
  const [campaignFilter, setCampaignFilter] = useState(null);
  const [isSearchForNetlinkinngOpen, setIsSearchForNetlinkinngOpen] =
    useState(false);

  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [confirmationSaveForce, setConfirmationSaveForce] = useState(false);
  const [confirmationMsgSaveForce, setConfirmationMsgSaveForce] = useState('');
  const [confirmationNotfiy, setConfirmationNotify] = useState(false);
  const [confirmationMsgNotfiy, setConfirmationMsgNotfiy] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [wantedLinksFocus, setWantedLinksFocus] = useState(false);
  const [wantedLinksList, setWantedLinksList] = useState([]);
  const [wantedLinks, setWantedLinks] = useState('');
  const location = useLocation();
  const [modalAddSingleWanted, setModalAddSingleWanted] = useState(false);
  const [active, setActive] = useState(1);
  const [checkedSpots, setCheckedSpots] = useState([]);
  const [renotifySuperConsultantTmp, setRenotifySuperConsultantTmp] =
    useState(false);

  const navItems = [
    { text: t('Spots proposés'), active: 1 },
    { text: t('Spots sélectionnés'), active: 2 },
    { text: t('Historique Backlinks'), active: 3 },
  ];
  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
    document.title = t('PixLink - Detail campaign');
  }, [t]);


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const win = searchParams.get("win");

    if (win == 2) {
      setActive(2);
    }
  }, [location.search]);
  useEffect(() => {
    axiosPixLink
      .get(
        API.getCampaignDetail +
        `${window.location.href.split('/')[
        window.location.href.split('/').length - 1
        ]
        }`
      )
      .then((res) => {
        setCampaignFilter(res.data);
        setWantedNetlinkings(res.data.wantedNetlinkings);
        setHistoricBackLinkings(res.data.historicBackLinkings);
        setNetlinkingsTmp(res.data.netlinkingSelecteds);
        handleTmpNetlinkingData(res.data.netlinkingSelecteds)
        setNetlinkings(res.data.netlinkingSelecteds);
        handleNetlinkingData(res.data.netlinkingSelecteds)
        setNbrOfLinksDemanded(res.data.linksNumbers);
      });
  }, []);

  function sendNetlinkingChoose(data) {
    const newData = data.map((item) => {
      if (!item.hasOwnProperty('netlinking')) {
        const newSchemaItem = {
          id: null,
          netlinking: {
            id: item?.id,
            domain: item?.domain,
            kwPositioned: item?.kwPositioned,
            trafic: item?.trafic,
            tF: item?.tF,
            cF: item?.cF,
            tarifHr: item?.tarifHr,
            conditions: item?.conditions,
            themesList: item?.themesList,
            topicsList: item?.topicsList,
            platformName: item?.platformName,
            platformPrice: item?.platformPrice,
            platformRC: item?.platformRC,
            platformHR: item?.platformHR,
            contactPhoneNumber: item?.contactPhoneNumber,
            languageId: item?.languageId,
            contact: item?.contact,
            tarifRc: item?.tarifRc,
            contactedTime: item?.contactedTime,
            type: item?.type
          },
          responsibleRedactio: null,

          responsiblePublication: null,
          programmationDate: null,
          publicationDate: null,
          contactDate: null,
          articleLink: null,
          spotLink: null,
          ancreLink: null,
          insertionLink: null,
          publicationStatus: null,
          redactionStatus: null,
          spotStatus: null,
        };
        return newSchemaItem;
      }

      return item;
    });

    //  setNetlinkingsTmp(newData);
    //handleTmpNetlinkingData(newData)
    SaveNetlinkingToCampaignsSilent(newData);
  }
  const handleWantedLinksChange = (data) => {
    setWantedLinksList(data);
    axiosPixLink
      .post(`/campaign/addWantedNetlinkingFileSelection/${id}`, data)
      .then((res) => {
        const { rejectedDomains } = res.data?.body ?? {};

        if (rejectedDomains && rejectedDomains.length > 0) {
          setIsSuccess(false);
          setErrorSuccessMsg(
            `${rejectedDomains.length} domaine(s) rejeté(s) :\u2028` +
            rejectedDomains.map((d) => `• ${d}`).join('\u2028')
          );
        } else {
          setIsSuccess(true);
          setErrorSuccessMsg(`${t('Spot ajouté au favoris')} !`);
        }
        setErrorSuccess(true);

        axiosPixLink.get(API.getCampaignDetail + id).then((res2) => {
          setCampaignFilter(res2.data);
          setWantedNetlinkings(res2.data.wantedNetlinkings);
          setHistoricBackLinkings(res2.data.historicBackLinkings);
          setNetlinkingsTmp(res2.data.netlinkingSelecteds);
          handleTmpNetlinkingData(res2.data.netlinkingSelecteds);
          setNetlinkings(res2.data.netlinkingSelecteds);
          handleNetlinkingData(res2.data.netlinkingSelecteds);
          setNbrOfLinksDemanded(res2.data.linksNumbers);
        });
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 599:
            setErrorSuccessMsg('Attention le spot ajouté ' + e.response.data + ' semble être dupliqué');
            break;
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  const hasCheckedBlueSpots = checkedSpots.some(
    (item) => item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT
  );

  const allCheckedAreBlue = checkedSpots.length > 0 &&
    checkedSpots.every(
      (item) => item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT
    );
  const hasUncheckedBlueSpots = netlinkings.some(
    (item) =>
      item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT &&
      !checkedSpots.some((c) => c.netlinking.id === item.netlinking.id)
  );
  const handleWantedLinksChangeSingle = (data) => {
    setWantedLinksList(data);
    axiosPixLink
      .post(
        `/campaign/addWantedNetlinkingFileSelection/${id}`,
        data
      )
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(
          `${t('Spot ajouté au favoris')} !`
        );
        setErrorSuccess(true);
        window.location.reload();
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const SaveNetlinkingToCampaignsSilent = (newData) => {
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        newData.map((object) => ({
          ...object,
          publicationStatus: object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus: object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then(() => {
        // ✅ Refetch depuis le backend pour avoir les vrais statuts
        axiosPixLink
          .get(API.getCampaignDetail + id)
          .then((res) => {
            const freshData = res.data.netlinkingSelecteds;
            setNetlinkings(freshData);
            handleNetlinkingData(freshData);
            setNetlinkingsTmp(freshData);
            handleTmpNetlinkingData(freshData);
          });
      })
      .catch((e) => {
        console.error('Error:', e?.response?.status, e?.response?.data);
      });
  };
  useEffect(() => {
    console.log(netlinkingsTmp);
  },);
  function removeNetlinkingId(items) {
    const updatedNetlinkings = netlinkings.filter(
      (netlinking) =>
        !items.some((item) => item.netlinking.id === netlinking.netlinking.id)
    );
    setNetlinkingsTmp(updatedNetlinkings);
    handleTmpNetlinkingData(updatedNetlinkings)
    setNetlinkings(updatedNetlinkings);
    handleNetlinkingData(updatedNetlinkings)
    RemoveNetlinkingToCampaigns(updatedNetlinkings);
  }

  const RemoveNetlinkingToCampaigns = (netlinkingswithoutSpot) => {
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        netlinkingswithoutSpot.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings(netlinkingswithoutSpot);
        handleNetlinkingData(netlinkingswithoutSpot)
        setErrorSuccessMsg(
          `${t('Les spots')} ${t('ont été supprimés avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  useEffect(() => {
    console.log("CAMAPIGN STATUS", campaignStatus);
  },);
  const sendUpdateSaveSelectedNetlinking = (updatedData) => {
    setNetlinkingsTmp(updatedData);
    handleTmpNetlinkingData(updatedData)
    setNetlinkings(updatedData);
    handleNetlinkingData(updatedData)
  };

  const SaveNetlinkingToCampaigns = () => {
    setConfirmationSaveForce(false);
    setNetlinkings(netlinkingsTmp);
    handleNetlinkingData(netlinkingsTmp)
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        netlinkingsTmp.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings(netlinkingsTmp);
        handleNetlinkingData(netlinkingsTmp)
        sendNewCampaignTarif();
        setErrorSuccessMsg(
          `${t('Les spots')} ${t('ont été ajoutés avec succes')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  function haveSharedDomain(array1, array2) {
    // Extract domains from array1
    const domains1 = array1.map((obj) => obj?.netlinking?.domain);

    // Iterate over array2 and check if any domain matches
    for (let i = 0; i < array2.length; i++) {
      if (domains1.includes(array2[i]?.domain)) {
        return true; // If match found, return true
      }
    }

    return false; // If no match found, return false
  }

  const GlobalSaveNetlinkingToCampaigns = () => {
    if (haveSharedDomain(netlinkings, historicBackLinkings)) {
      setConfirmationMsgSaveForce(
        "Attention, vous allez ajouter un domaine qui existe dans la liste d'historique backlinks. Êtes-vous sûre de vouloir continuer ?"
      );
      setConfirmationSaveForce(true);
    } else {
      setConfirmationMsgSaveForce(
        t('Étes-vous sûre de vouloir valider la sélection des spots ? ')
      );
      setConfirmationSaveForce(true);
    }
  };

  const NotifierPixalioneNetlinkingToCampaigns = () => {
    axiosPixLink
      .post(
        `/campaign/NotifySuperAdminSuperConsultantSelectedNetlinking/${id}`,
        !campaignType
          ? netlinkings.map((object) => ({
            ...object,
            publicationStatus:
              object.publicationStatus === ''
                ? null
                : object.publicationStatus,
            redactionStatus:
              object.redactionStatus === '' ? null : object.redactionStatus,
            spotStatus: object.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT ? PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT : PIXLINK_STATUS.TO_BE_VALIDATED_SUPER_ADMIN,
          }))
          : netlinkings.map((object) => ({
            ...object,
            publicationStatus:
              object.publicationStatus === ''
                ? null
                : object.publicationStatus,
            redactionStatus:
              object.redactionStatus === '' ? null : object.redactionStatus,
            spotStatus: object.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT ? PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT : PIXLINK_STATUS.TO_BE_VALIDATED_SUPER_ADMIN,
          }))
      )
      .then((res) => {
        setCampaignStatus(PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_ADMIN_TO_BE_APPROVED);
        setRenotifySuperConsultantTmp(false);
        setIsSuccess(true);

        if (!campaignType) {
          setRenotifySuperConsultantTmp(true);
          const newNetlinking = netlinkings.map((item) => {
            if (item.spotStatus === PIXLINK_STATUS.REFUSED_PIXALIONE) {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.REFUSED_PIXALIONE,
              };
            } else if (item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT,
              };
            } else if (item.spotStatus === PIXLINK_STATUS.TO_BE_COMMANDED) {
              return { ...item, spotStatus: PIXLINK_STATUS.TO_BE_COMMANDED }
            } else if (item.spotStatus === PIXLINK_STATUS.REFUSED_CLIENT) {
              return { ...item, spotStatus: PIXLINK_STATUS.REFUSED_CLIENT }
            } else {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.TO_BE_VALIDATED_SUPER_ADMIN,
              };
            }
          })
          setNetlinkings(newNetlinking);
          handleNetlinkingData(newNetlinking)
        } else {
          const newNetlinking = netlinkings.map((item) => {
            if (item.spotStatus === PIXLINK_STATUS.REFUSED_PIXALIONE) {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.REFUSED_PIXALIONE,
              };
            } else if (item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT,
              };
            } else {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.TO_BE_VALIDATED_SUPER_ADMIN,
              };
            }
          })
          setNetlinkings(newNetlinking);
          handleNetlinkingData(newNetlinking)
        }
        setErrorSuccessMsg(
          campaignType
            ? `${t('Super Admin et Super Consultant ont été notifiés avec succès')} !`
            : `${t('Super Admin et Super Consultant ont été notifiés avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const NotifierSuperAdminFilteringNetlinkingToCampaigns = () => {
    axiosPixLink
      .post(
        `/campaign/NotifySuperAdminFilteredSelectedNetlinking/${id}`,
        checkedSpots
          .map((object) => ({
            ...object,
            publicationStatus:
              object.publicationStatus === '' ? null : object.publicationStatus,
            redactionStatus:
              object.redactionStatus === '' ? null : object.redactionStatus,
          }))

      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings((prevNetlinkings) => {
          const newData = prevNetlinkings.map((item) => {
            const isChecked = checkedSpots.some(
              (checked) => checked.netlinking.id === item.netlinking.id
            );
            if (isChecked) {
              return { ...item, spotStatus: PIXLINK_STATUS.TO_BE_COMMANDED };
            }
            return item;
          });
          handleNetlinkingData(newData); // keep parent in sync
          return newData;
        });
        setErrorSuccessMsg(
          campaignType
            ? `${t('Super Admin et Super Consultant ont été notifiés avec succès')} !`
            : `${t('Super Admin et Super Consultant ont été notifiés avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const NotifierSuperAdminNotEnoughNetlinkingToCampaigns = () => {
    axiosPixLink
      .post(
        `/campaign/NotifySuperAdminFilteredSelectedNetlinkingNotEnough/${id}`,
        netlinkings
          .map((object) => ({
            ...object,
            publicationStatus:
              object.publicationStatus === '' ? null : object.publicationStatus,
            redactionStatus:
              object.redactionStatus === '' ? null : object.redactionStatus,
          }))
          .filter(
            (item) =>
              item.spotTmpStatus !== PIXLINK_STATUS.NOT_FILTERED_CONSULTANT
          )
      )
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(
          campaignType
            ? `${t('Super Admin et Super Consultant ont été notifiés avec succès')} !`
            : `${t('Super Admin et Super Consultant ont été notifiés avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const NotifierSuperConsultntReinform = () => {
    axiosPixLink
      .post(
        `/campaign/NotifySuperAdminSelectedNetlinkingReinform/${id}`,
        netlinkings
          .map((object) => ({
            ...object,
            publicationStatus:
              object.publicationStatus === '' ? null : object.publicationStatus,
            redactionStatus:
              object.redactionStatus === '' ? null : object.redactionStatus,
          }))
          .filter(
            (item) =>
              item.spotTmpStatus !== PIXLINK_STATUS.NOT_FILTERED_CONSULTANT
          )
      )
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(
          campaignType
            ? `${t('Super Admin et Super Consultant ont été renotifiés avec succès')} !`
            : `${t('Super Admin et Super Consultant ont été renotifiés avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  return (
    <div>
      <div className="content-center">
        <div className="row-homePage">
        </div>
        <div className="col-12 col-md-8 mb-2">
          <ul className="nav nav-tabs nav-tabs-ct">
            {navItems.map((item, index) => (
              <li key={index} className="nav-item">
                <button
                  onClick={() => {
                    setActive(item.active);
                  }}
                  className={`nav-link ${item.active === active ? 'active' : ''
                    }`}
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                >
                  {item.text}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="row-homePage">
          {active === 1 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                {campaignFilter && (
                  <ConsultantSearchSpotTableControl
                    sendNetlinkingChoose={sendNetlinkingChoose}
                    netlinikingToChoseData={netlinkingsTmp}
                    netlinkingChosenData={netlinkings}
                    campaignStatus={campaignStatus}
                    campaignFilter={campaignFilter}
                    wantedNetlinkings={wantedNetlinkings}
                    historicBackLinkings={historicBackLinkings}
                  ></ConsultantSearchSpotTableControl>
                )}
                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
          {active === 2 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                <div className="box-list-header"></div>
                <ConsultantSelectedSpotTableControl
                  netlinkings={netlinkings.filter(
                    (item) =>
                      item.spotStatus !== PIXLINK_STATUS.REFUSED_PIXALIONE
                  )}
                  campaignFilter={null}
                  wantedNetlinkings={wantedNetlinkings}
                  removeNetlinkingId={removeNetlinkingId}
                  SaveNetlinkingToCampaigns={SaveNetlinkingToCampaigns}
                  sendUpdateSaveSelectedNetlinking={
                    sendUpdateSaveSelectedNetlinking
                  }
                  campaignStatus={campaignStatus}
                  historicBackLinkings={historicBackLinkings}
                  campaignType={campaignType}
                  sendNewCampaignTarif={sendNewCampaignTarif}
                  sendCheckedItems={(items) => setCheckedSpots(items)}
                ></ConsultantSelectedSpotTableControl>

                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
          {active === 3 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                <div className="box-list-header"></div>
                <ConsultantHistoricalBacklinkingsTableControl
                  historicBackLinkings={historicBackLinkings}
                  campaignFilter={null}
                  wantedNetlinkings={wantedNetlinkings}
                  removeNetlinkingId={removeNetlinkingId}
                  SaveNetlinkingToCampaigns={SaveNetlinkingToCampaigns}
                ></ConsultantHistoricalBacklinkingsTableControl>
                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
        </div>
        {active === 2 && (
          <span>
            {netlinkings.length < 1 ? (
              <>
                <button
                  className="bt-submit-disabled-y"
                  style={{ margin: '0 auto', marginTop: '5px', marginLeft: '5px', alignSelf: 'right', float: 'right' }}
                >
                  {t('Informer')}
                </button>
                <button
                  className="bt-submit-y"
                  style={{ margin: '0 auto', marginTop: '5px', marginLeft: '5px', alignSelf: 'right', float: 'right' }}
                  onClick={NotifierSuperAdminNotEnoughNetlinkingToCampaigns}
                >
                  {t('Alerte spots insuffisants')}
                </button>
              </>

            ) : allCheckedAreBlue ? (
              <button
                className="bt-submit-y"
                style={{ margin: '0 auto', marginTop: '5px', marginLeft: '5px', alignSelf: 'right', float: 'right' }}
                onClick={NotifierSuperAdminFilteringNetlinkingToCampaigns}
              >
                {t('Prêt à lancer')}
              </button>

            ) : campaignStatus === 'CAMPAIGN_NOTIFIED_CONSULTANT_TO_BE_FILTERED' &&
              !renotifySuperConsultantTmp ? (
              <>
                {checkedSpots.length > 0 ? (
                  <button
                    className="bt-submit-y"
                    style={{ margin: '0 auto', marginTop: '5px', marginLeft: '5px', alignSelf: 'right', float: 'right' }}
                    onClick={NotifierPixalioneNetlinkingToCampaigns}
                  >
                    {t('Informer')}
                  </button>
                ) : (
                  <button
                    className="bt-submit-disabled-y"
                    style={{ margin: '0 auto', marginTop: '5px', marginLeft: '5px', alignSelf: 'right', float: 'right' }}
                  >
                    {t('Prêt à lancer')}
                  </button>
                )}
              </>

            ) : (!campaignStatus ||
              campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_STARTED_TO_BE_SELECTED_BY_CONSULTANT ||
              campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_ADMIN_TO_BE_APPROVED) &&
              !renotifySuperConsultantTmp &&
              campaignStatus !== PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_ADMIN_SUPER_CONSULTANT_TO_BE_APPROVED ? (
              <button
                className="bt-submit-y"
                style={{ margin: '0 auto', marginTop: '5px', marginLeft: '5px', alignSelf: 'right', float: 'right' }}
                onClick={NotifierPixalioneNetlinkingToCampaigns}
              >
                {t('Informer')}
              </button>

            ) : (
              <button
                className="bt-submit-y"
                style={{ margin: '0 auto', marginTop: '5px', marginLeft: '5px', alignSelf: 'right', float: 'right' }}
                onClick={NotifierSuperConsultntReinform}
              >
                {t('Reinformer')}
              </button>
            )}


            {(<span>
              <div className="">
                <div className="">
                  <div className={''}>
                    <button
                      className="bt-submit-y"
                      style={{
                        margin: '0 auto',
                        marginTop: '5px',
                        marginLeft: '5px',
                        alignSelf: 'right',
                        float: 'left',
                      }}
                      onClick={() => { setModalAddSingleWanted(true) }}
                    >
                      {t('Ajouter Spot')}
                    </button>
                  </div>
                  <div className={''}>
                    <div>
                      <span>
                        <ExcelUploaderSelection
                          handleLinksChange={handleWantedLinksChange}
                          sendFileName={(name) => {
                            setWantedLinks(name);
                          }}
                          type="wantedLinks"
                        ></ExcelUploaderSelection>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </span>)}
          </span>
        )}
      </div>

      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => {
          setErrorSuccess(false);
        }}
        success={isSuccess}
      />
      <ConfirmationModal
        open={confirmationSaveForce}
        message={confirmationMsgSaveForce}
        handleClose={() => setConfirmationSaveForce(false)}
        executeAction={SaveNetlinkingToCampaigns}
      />
      <ErrorSuccesModal
        open={confirmationMsgNotfiy}
        message={confirmationMsgNotfiy}
        handleClose={() => {
          setErrorSuccess(false);
          //       history.goBack();
        }}
        success={isSuccess}
      />
      <UploadSpotModal
        open={modalAddSingleWanted}
        handleClose={() => { setModalAddSingleWanted(false) }}
        executeAction={handleWantedLinksChangeSingle}
      />
    </div>
  );
}
